import React from 'react'
import {Global} from '@emotion/react'
import adyen_css from '../../../integrations/adyen/styles/adyen.css.js'

const AdyenGlobalStyles = () => (
    <Global styles={adyen_css} />
)

export {AdyenGlobalStyles}
